// Always-loaded vendors
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'sharer.js';
import 'formdata-polyfill';
import './modules/remodal';
import './modules/lightbox';

import loadGoogleMaps from './modules/load-google-maps';
import whenNearScreen from './modules/when-near-screen';

// Always-loaded components (present on every page)
import cookieBanner from '../../templates/components/cookie-banner';
import headerToggle from '../../templates/components/header/header-toggle';
import headerSearch from '../../templates/components/header/search';
import headerClose from '../../templates/components/header/close';
import menuOpener from '../../templates/components/header/menu-opener';
import linkDropdown from '../../templates/components/header/link-dropdown';
import menu from '../../templates/components/menu';
import pageOverlay from '../../templates/components/page-overlay';

cookieBanner();
headerToggle();
headerSearch();
headerClose();
menuOpener();
linkDropdown();
menu();
pageOverlay();

// Dynamic imports — all fire in parallel immediately (script is deferred so DOM is ready)
if (document.querySelector('[js-hero-carousel-bg-slider]')) {
    import('../../templates/components/hero-carousel').then(({ default: heroCarousel }) => heroCarousel());
}
if (document.querySelector('#hero-carousel__storage-counter')) {
    import('../../templates/components/hero-carousel/StorageCounter').then(({ default: storageCounter }) => storageCounter());
}
if (document.querySelector('[js-secondary-body-opener]')) {
    import('../../templates/components/text-block/secondary-body').then(({ default: secondaryBody }) => secondaryBody());
}
if (document.querySelector('[js-card-carousel-slider]')) {
    import('../../templates/components/card-carousel').then(({ default: cardCarousel }) => cardCarousel());
}
// The social feed is switched off at the moment; this is ready for if it's back
if (document.querySelector('[js-social-carousel-slider]')) {
    import('../../templates/components/social').then(({ default: social }) => social());
}
if (document.querySelector('[js-hero-gallery]')) {
    import('../../templates/components/hero-gallery').then(({ default: heroGallery }) => heroGallery());
}
if (document.querySelector('[js-workspace-types-track]')) {
    import('../../templates/components/workspace-types').then(({ default: workspaceTypesCarousel }) => workspaceTypesCarousel());
}
if (document.querySelector('[js-workspace-locations-track]')) {
    import('../../templates/components/workspace-locations').then(({ default: workspaceLocationsCarousel }) => workspaceLocationsCarousel());
}
if (document.querySelector('[js-benefits-strip-track]')) {
    import('../../templates/components/workspace-benefits').then(({ default: benefitsStripCarousel }) => benefitsStripCarousel());
}
if (document.querySelector('[js-accordion-header]')) {
    import('../../templates/components/accordion').then(({ default: accordion }) => accordion());
}
if (document.querySelector('[js-video-block]')) {
    import('../../templates/components/video-block').then(({ default: videoBlock }) => videoBlock());
}
if (document.querySelector('[js-single-map]')) {
    // Google Maps loads as the map comes near the screen rather than with the
    // page, keeping its start-up work away from people's first taps (INP)
    whenNearScreen(document.querySelectorAll('[js-single-map]'), () => loadGoogleMaps()
        .then(() => import('../../templates/components/single-map'))
        .then(({ default: singleMap }) => singleMap()));
}
if (document.querySelector('[js-gallery-slider]')) {
    import('../../templates/components/gallery-slider').then(({ default: gallerySlider }) => gallerySlider());
}
if (document.querySelector('.sf-price-calculator')) {
    import('../../templates/components/price-calculator/store-first').then(({ default: sfPriceCalculator }) => sfPriceCalculator());
}
if (document.querySelector('.bf-price-calculator')) {
    import('../../templates/components/price-calculator/business-first').then(({ default: bfPriceCalculator }) => bfPriceCalculator());
}
if (document.querySelector('.js-text-field-input')) {
    import('../../templates/components/text-field').then(({ default: textField }) => textField());
    import('../../templates/components/textarea').then(({ default: textarea }) => textarea());
}
if (document.querySelector('#location-list')) {
    import('../../templates/components/location-list').then(({ default: locationList }) => locationList());
}
if (document.querySelector('[js-scroll-to]')) {
    import('../../templates/components/location-footer').then(({ default: locationFooter }) => locationFooter());
}
if (document.querySelector('[js-location-footer-nav-opener]')) {
    import('../../templates/components/location-footer/nav-opener').then(({ default: locationFooterNavOpener }) => locationFooterNavOpener());
}
if (document.querySelector('[js-location-card]')) {
    import('../../templates/components/location-card').then(({ default: locationCard }) => locationCard());
}
// The location list's map loads Google Maps the first time it's opened
// (location-list/show-map), so it isn't loaded while the map is closed
if (document.querySelector('#toggleMap')) {
    import('../../templates/components/location-list/toggle-map').then(({ default: toggleMap }) => toggleMap());
}
if (document.querySelector('.js-mobile-map-opener')) {
    import('../../templates/components/location-list/mobile-map-opener').then(({ default: mobileMapOpener }) => mobileMapOpener());
}
if (document.querySelector('.articles-list')) {
    import('../../templates/components/articles-list').then(({ default: articlesList }) => articlesList());
}
if (document.querySelector('.js-articles-list-filter-opener')) {
    import('../../templates/components/articles-list/filter-opener').then(({ default: filterOpener }) => filterOpener());
}
if (document.querySelector('[js-tabs]')) {
    import('../../templates/components/tabs').then(({ default: tabs }) => tabs());
}
if (document.querySelector('[js-card-reviews]')) {
    import('../../templates/components/review-cards').then(({ default: reviewCards }) => reviewCards());
}
if (document.querySelector('.enquiry-form')) {
    import('../../templates/components/enquiry-form').then(({ default: enquiryForm }) => enquiryForm());
    import('../../templates/components/enquiry-form/tracking').then(({ default: enquiryTracking }) => enquiryTracking());
}
if (document.querySelector('#newsletterSignupForm')) {
    import('../../templates/components/footer/components/newsletter-form').then(({ default: newsletterSignupForm }) => newsletterSignupForm());
}
if (document.querySelector('.js-timeline-image-carousel')) {
    import('../../templates/components/timeline/timeline').then(({ default: timeline }) => timeline());
}
if (document.querySelector('.js-brochure-download')) {
    import('../../templates/components/hero/brochure').then(({ default: handleBrochureDownload }) => handleBrochureDownload());
}
if (document.querySelector('.js-book-viewing')) {
    import('../../templates/components/bookviewing-form/bookviewing').then(({ default: handleBookViewing }) => handleBookViewing());
}
if (document.querySelector('[js-bf-hero-finder]')) {
    import('../../templates/components/hero/bf-hero-finder').then(({ default: handleBfHeroFinder }) => handleBfHeroFinder());
}
if (document.querySelector('.properties-list')) {
    import('../../templates/components/properties-list').then(({ default: propertiesList }) => propertiesList());
}
if (document.querySelector('[js-iframe-slider]')) {
    import('../../templates/components/iframe-slider').then(({ default: iframeSlider }) => iframeSlider());
}
if (document.querySelector('#spreadsheet-id')) {
    import('../../templates/components/comparison-price-table').then(({ default: comparisonPriceTable }) => comparisonPriceTable());
}
if (document.querySelector('[js-sf-info-card-header]')) {
    import('../../templates/components/sf-location-info-cards').then(({ default: initLocationInfoCards }) => initLocationInfoCards());
}
if (document.querySelector('[js-sf-mobile-contact-trigger]')) {
    import('../../templates/components/location-footer/mobile-contact').then(({ default: initMobileContact }) => initMobileContact());
}
if (document.querySelector('.js-carousel')) {
    import('../../templates/components/carousel').then(({ default: initSimpleCarousel }) => initSimpleCarousel());
}
if (document.querySelector('.js-video-card')) {
    import('../../templates/components/card-video').then(({ initVideoCards }) => initVideoCards());
}
if (document.querySelector('[js-card-video-inline]')) {
    import('../../templates/components/card-video/inline').then(({ default: initInlineVideoCards }) => initInlineVideoCards());
}
if (document.querySelector('.info-gallery__slide')) {
    import('../../templates/components/info-gallery').then(({ initInfoGallery }) => initInfoGallery());
}
if (document.querySelector('[js-countdown]')) {
    import('../../templates/components/countdown').then(({ default: countdown }) => countdown());
}
if (document.querySelector('[js-countdown-room]')) {
    import('../../templates/components/countdown/room').then(({ default: countdownRoom }) => countdownRoom());
}
if (document.querySelector('[js-hero-video]')) {
    import('../../templates/components/hero/black-friday-video').then(({ default: heroVideo }) => heroVideo());
}
if (document.querySelector('[js-bf-columns]')) {
    import('../../templates/components/hero/black-friday-columns').then(({ default: blackFridayColumns }) => blackFridayColumns());
}
